import script from "./AgentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentForm.vue?vue&type=script&lang=ts&setup=true"

import "./AgentForm.vue?vue&type=style&index=0&id=0d6b7a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6b7a2c"]])

export default __exports__